export enum DOCUMENTS {
  REPORT_EXPOST = 'rapport-frais-expost',
  REPORT_REGULAR_ADVISORY = 'rapport-conseil-regulier',
  REPORT_FREE_PAYMENT = 'versement-libre-en-ligne',
}
